import { ImageUpload } from "@/components/DesignPanel";

const inputCls = "w-full h-9 px-3 rounded-md bg-[#0B0F17] border border-[#242C3D] text-sm focus:border-indigo-500 focus:outline-none";
const label = "block font-mono text-[11px] uppercase tracking-widest text-slate-500 mb-2";

const FIELDS = [
  ["show_date", "Date"],
  ["show_email", "Email"],
  ["show_start", "Start time"],
  ["show_end", "End time"],
  ["show_duration", "Total duration"],
];

export const ReportEditor = ({ report, setReport }) => {
  const set = (patch) => setReport({ ...report, ...patch });
  return (
    <div className="space-y-5" data-testid="report-editor">
      <p className="text-xs text-slate-500 -mt-2">Each lead gets a printable attendance report (webinar title + these details), opened from the leads table.</p>
      <div className="grid sm:grid-cols-2 gap-5">
        <div>
          <span className={label}>Report title line</span>
          <input data-testid="report-heading-input" value={report.heading} onChange={(e) => set({ heading: e.target.value })} className={inputCls} placeholder="Attendance Report" />
        </div>
        <div>
          <span className={label}>Subtitle</span>
          <input data-testid="report-subtitle-input" value={report.subtitle} onChange={(e) => set({ subtitle: e.target.value })} className={inputCls} placeholder="Certificate of viewing" />
        </div>
      </div>
      <div>
        <span className={label}>Logo</span>
        <ImageUpload value={report.logo_path} onChange={(p) => set({ logo_path: p })} testid="report-logo-upload" emptyLabel="Upload report logo" />
      </div>
      <div>
        <span className={label}>Fields shown on the report</span>
        <div className="flex flex-wrap gap-2">
          {FIELDS.map(([key, name]) => (
            <button key={key} type="button" data-testid={`report-toggle-${key}`} onClick={() => set({ [key]: !report[key] })}
              className={`h-9 px-3.5 rounded-full text-xs border transition-colors ${report[key] ? "border-indigo-500 bg-indigo-500/15 text-indigo-200" : "border-[#242C3D] text-slate-400 hover:text-white"}`}>
              {name}
            </button>
          ))}
        </div>
      </div>
      <div>
        <span className={label}>Footer note</span>
        <textarea data-testid="report-footer-input" rows={2} value={report.footer} onChange={(e) => set({ footer: e.target.value })}
          placeholder="This document confirms attendance…" className={`${inputCls} h-auto py-2 resize-none text-xs`} />
      </div>
    </div>
  );
};
